import { masterLang } from './const';
import { useQuery } from './quiz/hooks/use-query';

export const useLang = () => {
  const {
    query: { lang: currentLang = masterLang },
  } = useQuery();
  const lang = Array.isArray(currentLang) ? currentLang[0] : currentLang;

  return {
    lang,
  };
};
